module.exports = __webpack_public_path__ + "static/aftermovie-97a10397386046cfaa4e3c8b98fcf0fd.mp4";